import styled from 'styled-components';

export const SupportHintBox = styled.div.attrs({
  className: 'space-y-0.5',
})``;

export const SupportHintTitle = styled.p.attrs({
  className: 'text-xs font-semibold',
})``;

export const SupportHintText = styled.p.attrs({
  className: 'text-xs text-muted-foreground',
})``;

export const SupportHintLink = styled.a.attrs({
  className: 'text-primary underline-offset-4 hover:underline',
})``;
